// @builder.io/qwik/build
export const isServer = false;
export const isBrowser = true;
export const isDev = false;
